export const WORKSHOPS_DATA = [
  {
    id: "01",
    slug: "coding-basic-workshop-s2t",
    title: "Coding - Basic",
    isOffered: false,
    isPublished: true,
    isFeatured: true,
    imgUrl: "assets/images/workshop/kids-learning.webp",
    students: 5.3,
    rating: 1.7,
  },
  {
    id: "02",
    slug: "web-basic-workshop-s2t",
    title: "Web - Basic",
    isOffered: false,
    isPublished: true,
    isFeatured: true,
    imgUrl: "assets/images/workshop/web-development.webp",
    students: 5.3,
    rating: 1.7,
  },
  {
    id: "03",
    slug: "seo-basic-workshop-s2t",
    title: "SEO - Basic",
    isOffered: false,
    isPublished: true,
    isFeatured: true,
    imgUrl: "assets/images/workshop/seo.webp",
    students: 5.3,
    rating: 1.7,
  },
  {
    id: "04",
    slug: "ui-ux-basic-workshop-s2t",
    title: "UI/UX Design - Figma",
    isOffered: false,
    isPublished: true,
    isFeatured: true,
    imgUrl: "assets/images/workshop/ui-ux.webp",
    students: 5.3,
    rating: 1.7,
  },
];
